import ArrowRightAlt from '@mui/icons-material/ArrowRightAlt';
import BusinessIcon from '@mui/icons-material/Business';
import Check from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import Pencil from '@mui/icons-material/Edit';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterListIcon from '@mui/icons-material/FilterList';
import Flag from '@mui/icons-material/Flag';
import GavelIcon from '@mui/icons-material/Gavel';
import GroupAdd from '@mui/icons-material/GroupAdd';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsPhoneIcon from '@mui/icons-material/SettingsPhone';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export const AccountIcon = SettingsIcon;
export const AddLeadsIcon = GroupAdd;
export const CampaignIcon = TrendingUpIcon;
export const CheckIcon = Check;
export const DashboardIcon = HomeIcon;
export const DncComplainerIcon = GavelIcon;
export const DncIcon = PhoneDisabledIcon;
export const DncLitigatorIcon = GavelIcon;
export const ExitToAppIconIcon = ExitToAppIcon;
export const ExpandCloseIcon = ExpandLessIcon;
export const ExpandOpenIcon = ExpandMoreIcon;
export const FlagIcon = Flag;
export const OrganizationIcon = BusinessIcon;
export const PencilIcon = Pencil;
export const PhoneLookupIcon = SettingsPhoneIcon;
export const PhoneNumberIcon = PhoneIcon;
export const RightArrowIcon = ArrowRightAlt;
export const UserIcon = PersonOutlineIcon;

export { CloseIcon, DeleteIcon, FilterListIcon, MenuIcon };
